import config from "../../src/config";

export enum DISPLAY_TYPES {
  EVERYONE = "everyone",
  SELECTED = "selected",
  NOBODY = "nobody",
}

export enum SETTINGS_COLLAPSES {
  PROFILE = "profile",
  THEME = "theme",
  PRIVACY = "privacy",
  SECURITY = "security",
  HELP = "help",
}

export interface DisplayOpt {
  label: string;
  value: DISPLAY_TYPES;
}

export const DisplayTypes: Array<DisplayOpt> = [
  { label: "Everyone", value: DISPLAY_TYPES.EVERYONE },
  { label: "Nobody", value: DISPLAY_TYPES.NOBODY },
  { label: "Selected", value: DISPLAY_TYPES.SELECTED },
];

export enum STATUS_TYPES {
  ACTIVE = "Active",
  AWAY = "Away",
  DO_NOT_DISTURB = "Do not disturb",
}

// Detect protocol from browser (works for both local HTTPS dev and production)
const isSecure =
  typeof window !== "undefined" && window.location.protocol === "https:";
const httpProtocol = isSecure ? "https" : "http";
const wsProtocol = isSecure ? "wss" : "ws";

// When REACT_APP_USE_LOCAL_PROXY=true, use relative URLs so API calls go through
// the dev server proxy (for local dev with remote backend via setupProxy.js)
const useLocalProxy = process.env.REACT_APP_USE_LOCAL_PROXY === "true";

export const URLS = {
  // Empty string = relative URLs = goes through dev server proxy
  CLIENT_URL: useLocalProxy ? "" : `${httpProtocol}://${config.CLIENT_URL}`,
  WEBSOCKET_URL: `${wsProtocol}://${config.CLIENT_URL}`,
  WEBSOCKET_Connect: `${wsProtocol}://${config.CLIENT_URL}`,
  // SSOR: Agent-Proxy URL for direct WebSocket connection
  AGENT_PROXY_WS_URL: config.AGENT_PROXY_URL
    ? `${wsProtocol}://${config.AGENT_PROXY_URL}`
    : null,
  AGENT_PROXY_URL: config.AGENT_PROXY_URL
    ? `${httpProtocol}://${config.AGENT_PROXY_URL}`
    : null,
  // Feature flag for SSOR direct connection (string value, compared at runtime)
  USE_AGENT_PROXY: config.USE_AGENT_PROXY,
};

export const LINKS = {
  COMPANY_WEBSITE: "https://ittech.digital/",
  WHATSAPP_SUPPORT:
    "https://api.whatsapp.com/send/?phone=556199464630&text=Ol%C3%A1%2C+gostaria+de+mais+informa%C3%A7%C3%B5es.&type=phone_number&app_absent=0",
};

export const DOWNLOAD_LINKS = {
  WINDOWS: "https://jesss.ai/ConnectAI.exe",
  MAC: "https://jesss.ai/ConnectAI.dmg",
  LINUX: "https://jesss.ai/ConnectAI.tar.gz",
};

// Phone number configuration
export const PHONE_CONFIG = {
  // Default country for phone input
  DEFAULT_COUNTRY: "BR" as const,
  // Country calling code to strip when processing phone numbers
  DEFAULT_COUNTRY_CODE: "55",
  // Supported countries for phone input
  SUPPORTED_COUNTRIES: ["BR", "US", "PT", "ES", "AR"] as const,
};
